import * as THREE from 'three';
import $ from 'jquery';
import { assetDir } from '../config/paths';
import PopupManager from './PopupManager';
import logger from '../utils/logger';

const audioPaths = [
  ['present', `${assetDir}/sounds/01_gendai.aac`],
  ['modern', `${assetDir}/sounds/02_kindai.aac`],
  ['medieval', `${assetDir}/sounds/03_cyuusei.aac`],
  ['ancient', `${assetDir}/sounds/04_kodai.aac`],
];
const maxVolume = 1.0;

class SoundManager {
  constructor() {
    this.bgmHolder = {
      'present': undefined,
      'modern': undefined,
      'medieval': undefined,
      'ancient': undefined,
    };
    this.currentBGM;
    window.document.addEventListener('visibilitychange', this.onVisibilityChange.bind(this), false);
    // window.document.addEventListener('webkitvisibilitychange', this.onVisibilityChange.bind(this), false);
  }


  load() {
    const deferred = new $.Deferred();
    const manager = new THREE.LoadingManager();
    manager.onStart = function (url, itemsLoaded, itemsTotal) {
      logger.info('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
    };
    manager.onLoad = function () {
      logger.info('Loading complete!');
      deferred.resolve();
    };
    manager.onProgress = function (url, itemsLoaded, itemsTotal) {
      logger.info('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
    };
    manager.onError = function (url) {
      logger.info('There was an error loading ' + url);
      deferred.reject();
    };

    audioPaths.forEach(entry => {
      const key = entry[0];
      const path = entry[1];
      const audioLoader = new THREE.AudioLoader(manager);
      audioLoader.load(path, buffer => {
        const audio = new THREE.Audio(new THREE.AudioListener());
        audio.setBuffer(buffer);
        audio.setLoop(true);
        this.bgmHolder[key] = audio;
      });
    });
    return deferred.promise();
  }


  playBGM(bgmId) {
    if (
      bgmId === undefined ||
      this.bgmHolder[bgmId] === undefined ||
      this.bgmHolder[bgmId] === this.currentBGM ||
      PopupManager.isModalVisible()
    ) {
      return;
    }
    const nextBGM = this.bgmHolder[bgmId];
    nextBGM.setVolume(maxVolume);
    if (this.currentBGM && this.currentBGM.isPlaying) this.currentBGM.stop();
    if (!nextBGM.isPlaying) nextBGM.play();
    this.currentBGM = nextBGM;
  }


  replayBGM() {
    if (!this.currentBGM) return;
    if (!this.currentBGM.isPlaying) this.currentBGM.play();
  }


  muteBGM() {
    if (!this.currentBGM) return;
    if (this.currentBGM.isPlaying) {
      this.currentBGM.pause();
    }
  }


  onVisibilityChange(event) {
    if (window.document.visibilityState === 'visible') {
      if (this.currentBGM && !PopupManager.isModalVisible()) this.currentBGM.play();
    } else {
      if (this.currentBGM && this.currentBGM.isPlaying) this.currentBGM.pause();
    }
  }
}

export default new SoundManager();